<div class="flex flex-col h-full py-4 px-0 relative">
	<div
		class="flex flex-col h-full justify-between overflow-y-scroll -mx-6 px-6"
		[@openClose]
	>
		<div class="grid grid-rows-4 gap-x-8 gap-y-4 mb-4">
			<a
				externalNavInterceptor
				href="https://intercom.help/lawlabs/en/"
				target="_blank"
				class="hover:shadow-md cursor-pointer select-none rounded-xl grid grid-cols-8 place-items-center pl-2 py-2 pr-4"
				[testHook]="testHooks.HelpArticlesLink"
			>
				<div class="col-span-2">
					<img class="" src="/assets/images/support/article.svg" />
				</div>
				<div class="col-start-4 col-end-9">
					<h5 class="font-bold">View help articles</h5>
					<p class="xl:text-sm text-xs text-grey">
						Get help 24/7 with our collection of how-to content
					</p>
				</div>
			</a>
			<a
				externalNavInterceptor
				href="https://intercom.help/lawlabs/en/collections/3328625-recorded-webinars"
				target="_blank"
				class="hover:shadow-md cursor-pointer select-none rounded-xl grid grid-cols-8 place-items-center pl-2 py-2 pr-4"
				[testHook]="testHooks.VideoTutorialsLink"
			>
				<div class="col-span-2">
					<img class="" src="/assets/images/support/video.svg" />
				</div>
				<div class="col-start-4 col-end-9">
					<h5 class="font-bold">Watch video tutorials</h5>
					<p class="xl:text-sm text-xs text-grey">
						Watch and learn about Closer features and best practices
					</p>
				</div>
			</a>
			<a
				*ngIf="!isCollege"
				externalNavInterceptor
				[href]="'https://calendly.com/zahra-sharifi-lawlabs/60min'"
				target="_blank"
				class="hover:shadow-md cursor-pointer select-none rounded-xl grid grid-cols-8 place-items-center pl-2 py-2 pr-4"
				[testHook]="testHooks.BookTrainingLink"
			>
				<div class="col-span-2">
					<img class="" src="/assets/images/support/booking.svg" />
				</div>
				<div class="col-start-4 col-end-9">
					<h5 class="font-bold">Book a training</h5>
					<p class="xl:text-sm text-xs text-grey">
						Get 1:1 assistance with the basics or a particular topic of your
						interest
					</p>
				</div>
			</a>
			<a
				*ngIf="!isCollege"
				externalNavInterceptor
				href="https://calendly.com/zahra-sharifi-lawlabs/30min"
				target="_blank"
				class="hover:shadow-md cursor-pointer select-none rounded-xl grid grid-cols-8 place-items-center pl-2 py-2 pr-4"
				[testHook]="testHooks.DocTrainingLink"
			>
				<div class="col-span-2">
					<img class="" src="/assets/images/support/add-template.svg" />
				</div>
				<div class="col-start-4 col-end-9">
					<h5 class="font-bold">Add new documents</h5>
					<p class="xl:text-sm text-xs text-grey">
						Closer has 200+ built-in templates. Learn more with training from
						our client services team
					</p>
				</div>
			</a>
		</div>
	</div>

	<div class="pt-2 flex flex-col gap-4">
		<div>
			<h4>Get in touch</h4>
			<p class="text-sm text-grey-darker">
				Call <strong>1-888-520-4004</strong> to speak with a member of our
				Customer Success team.
			</p>
		</div>
		<a
			*ngIf="!isCollege"
			class="bot-trigger--feedback bottom-4 flex w-full cursor-pointer"
			[testHook]="testHooks.ChatLink"
		>
			<div
				class="lg:py-6 hover:shadow-md grid grid-cols-5 transition-all w-full items-center py-3 pl-3 pr-6 border-grey-light border-2 rounded-lg shadow-md"
				[ngClass]="{
					'border-grey-light': !isTeamOnline,
					'border-green-light bg-green-lightest': isTeamOnline,
				}"
			>
				<div class="flex flex-row col-span-2">
					<img
						class="max-h-12 max-w-12"
						[ngClass]="{ '-ml-8 2xl:-ml-4': index !== 1 }"
						*ngFor="let index of [1, 2, 3]"
						[src]="'/assets/images/support/avatars/' + index + '.svg'"
					/>
				</div>
				<div class="flex flex-col col-span-3 pl-2">
					<ng-container *ngIf="isTeamOnline">
						<p class="text-sm">We are online</p>
						<p class="xl:text-xl text-lg text-green-dark">
							Chat with us
							<app-icon
								class="ml-1 text-sm xl:inline-block hidden"
								small
								[icon]="ICON.OVERRIDE"
								[testHook]="testHooks.OverrideIcon"
							></app-icon>
						</p>
					</ng-container>
					<ng-container *ngIf="!isTeamOnline">
						<p class="xl:text-xl text-lg">Leave a message</p>
						<p class="text-sm">
							We will get back to you as soon as we are available
						</p>
					</ng-container>
				</div>
			</div>
		</a>
	</div>
</div>
